// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WN0Z","footer":"styles_footer__3AfoV","passCodeTooltip":"styles_passCodeTooltip__1CA07"};